var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ishome)?_c('div',{staticClass:"homeview-content"},[_c('div',{staticClass:"homeview-main"},[_c('canvas',{ref:"particleCanvas",attrs:{"id":"particle-canvas"}}),_c('Homemain',{on:{"goanalysis":_vm.goanalysis}})],1)]):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }